export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    width: 90,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: "字典编号",
    dataIndex: "code",
    key: "code",
    ellipsis: true,
  },
  {
    title: "字典名称",
    dataIndex: "dictValue",
    key: "dictValue",
    ellipsis: true,
  },
  {
    title: "字典键值",
    dataIndex: "dictKey",
    key: "dictKey",
    ellipsis: true,
  },
  {
    title: "字典排序",
    dataIndex: "sort",
    key: "sort",
  },
  {
    title: "封存",
    dataIndex: "isSealed",
    key: "isSealed",
    scopedSlots: { customRender: 'isSealed' }
  }
  
]
